import { render } from "./RewardPage.vue?vue&type=template&id=0b99cae6"
import script from "./RewardPage.vue?vue&type=script&lang=js"
export * from "./RewardPage.vue?vue&type=script&lang=js"

import "./RewardPage.vue?vue&type=style&index=0&id=0b99cae6&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__